import { config } from "@/config";

/** Global PostHog project key (hardcoded fallback for dev/local). */
const POSTHOG_GLOBAL_PROJECT_KEY =
	"phc_vCbyBuK48hfdALfigRCiaLunweodmY66WAput3j3zNhM";

export type PostHogSource = "amber_partners_dashboard";

export interface PostHogRuntimeConfig {
	apiKey: string;
	host: string;
	source: PostHogSource;
}

/**
 * Get PostHog configuration.
 * Uses env variable if set, otherwise falls back to hardcoded global key.
 */
export const getPostHogConfig = (): PostHogRuntimeConfig => {
	return {
		apiKey: config.posthog.apiKey || POSTHOG_GLOBAL_PROJECT_KEY,
		host: config.posthog.host || "https://posthog.amberstudent.com",
		source: "amber_partners_dashboard",
	};
};

/**
 * PostHog is only enabled client-side (not during SSR)
 */
export const isPostHogEnabled = (): boolean => typeof window !== "undefined";
